module.exports = __webpack_public_path__ + "img/flashlight.445186b0.svg";